import EventEmitter from 'events';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as MenuAction from '../actions/MenuAction';
class SupplierSuggestionStore extends EventEmitter {
    SearchresultList = "";
    SupplierStatus = "";
    SuccessStatus = "";
    FavitemAddList = "";
    workorderresponse = "";
    dynamicFormResponse = "";
    RatingSubmissionresponse = "";
    handleSupplierSuggestionStore = (action) => {
        switch (action.action.type) {
            case "TsSearchresult": {
         
                this.SearchresultList = action.action.response;
                this.emit('TsSearchresult');
                break;
            }
            case "SupplierStatus": {
                /*[05/10/22,WW-243-Cart Counter Updation, Priyanka D */
                MenuAction.refreshCartCount();
                this.SupplierStatus = action.action.response;
                this.emit('SupplierStatus');
                break;
            }
            //[12/15/22], PC_WW-552_FE_8, Dhevanesam R
            case "DynamicForm": {
                this.dynamicFormResponse = action.action.response;
                this.emit('DynamicForm');
                break;
            }



            case "RatingSubmissionresponse": {
                this.RatingSubmissionresponse = action.action.response;
                this.emit('RatingResponse');
                break;
            }


        }
    }

}

const objsuppliersugstore = new SupplierSuggestionStore;
Dispatcher.register(objsuppliersugstore.handleSupplierSuggestionStore.bind(objsuppliersugstore));
export default objsuppliersugstore;